<template>
  <!--委托信息模板列表-->
    <div ref="container">
      <el-popover placement="left-start" width="600"  trigger="manual" v-model="popoverVisible">
        <!-- 添加搜索框 -->
        <div class="search-box">
          <el-input
            ref="searchInput"
            v-model="searchQuery"
            placeholder="请输入模板名称搜索"
            prefix-icon="el-icon-search"
            clearable
            @clear="handleSearchClear"
            style="margin-bottom: 0px;width: 300px"
          />
        </div>

        <el-table
          @row-click="handleRowClick"
          :data="filteredGridData"
          height="500"
          style="width: 100%;">
          <el-table-column width="150" property="name" label="模板名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column property="details" label="内容" align="center">
            <template slot-scope="{row}">
              <div class="details-content">
                <el-tooltip placement="top" :open-delay="0">
                  <div slot="content">
                    {{ row.details.clientName +`&nbsp`+ row.details.clientPhone + row.details.clientEmail }}
                    <br/> {{ row.details.addressStr + row.details.fullAddress }}
                    <br/> {{ row.details.company + row.details.department }}
                    <br/> {{ row.details.teacherName + row.details.teacherPhone + row.details.teacherEmail }}
                    <br/> {{ row.details.registerAddress }}
                    <br/> {{ row.details.taxNumber }}
                    <br/> {{ row.details.bankAccount }}
                    <br/> {{ row.details.invoiceTitle }}
                  </div>
                  <div v-html="formatDetails(row.details)"></div>
                </el-tooltip>

<!--                <el-popover trigger="hover" placement="top">-->
<!--                  <p>姓名: {{ scope.row.name }}</p>-->
<!--                  <p>地址: {{ scope.row.address }}</p>-->
<!--                  <div slot="reference" v-html="formatDetails(scope.row.details)"></div>-->
<!--                </el-popover>-->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            property="isDefault"
            label="默认"
            width="50"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isDefault"
                :active-value="1"
                :inactive-value="0"
                @change="setDefault(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="140" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" @click="handleSelected(row)" title="使用该模板填充">使用</el-button>
              <el-button type="text" class="delete-btn" icon="el-icon-delete" title="删除"
                         @click="handleDelete(row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="text" slot="reference" @click="focusSearch">
          <i class="el-icon-folder-opened el-icon--right"></i>模板
        </el-button>
      </el-popover>
    </div>
  </template>

  <script>
  import {deleteOrderDataTemplate, getOrderDataTemplateList, updateOrderDataTemplate} from "@/api/orderDataTemplate";

  export default {
    data() {
      return {
        popoverVisible: false, // 控制删除确认框的显示与隐藏
        visible: false, // 控制删除确认框的显示与隐藏
        searchQuery: '', // 搜索关键词
        gridData: [{
          name: 'name',
          details: {"bankAccount":"","teacherEmail":"","address":"","teacherName":"","clientName":"","clientEmail":"","taxNumber":"","clientPhone":"","registerAddress":"","addressStr":"","addressList":[],"teacherPhone":"","fullAddress":"","company":"","department":"","invoiceTitle":""},
          isDefault: 1
        }]
      };
    },
    computed: {
      // 根据搜索关键词过滤数据
      filteredGridData() {
        if (!this.searchQuery) return this.gridData;
        return this.gridData.filter(item =>
          item.name && item.name.trim() && item.name.includes(this.searchQuery)
        );
      }
    },
    methods: {
      // 格式化显示内容
      formatDetails(details) {
        const detail = details || {
          "bankAccount": "",
          "teacherEmail": "",
          "address": "",
          "teacherName": "",
          "clientName": "",
          "clientEmail": "",
          "taxNumber": "",
          "clientPhone": "",
          "registerAddress": "",
          "addressStr": "",
          "teacherPhone": "",
          "fullAddress": "",
          "company": "",
          "department": "",
          "invoiceTitle": ""
        }

        const formattedContent = [
          `${detail.clientName} ${detail.clientPhone} ${detail.clientEmail} ${detail.addressStr} ${detail.fullAddress}`,
          `${detail.company} ${detail.department} ${detail.teacherName} ${detail.teacherPhone} ${detail.teacherEmail}`,
          `${detail.registerAddress} ${detail.taxNumber} ${detail.bankAccount} ${detail.invoiceTitle}`
        ].join('')
        // ].join('<br>')
        return formattedContent
      },
      // 设置默认模板
      async setDefault(row) {
        this.gridData.forEach(item => {
          if (item.name !== row.name) {
            item.isDefault = 0;
          }
        });
        let params = {...row}
        params.details = JSON.stringify(row.details)
        updateOrderDataTemplate(params).then(res => {
          if (res.code === 200) {
            this.$message.success('修改成功');
          }
        });
      },
      // 使用模板
      async handleSelected(row) {
        // 发送事件
        this.$emit('selectedTemplate', row.details)
        this.popoverVisible = false
      },
      // 删除模板
      async handleDelete(row) {
        this.$confirm(`确认删除该模板吗？`, '提示', {type: 'warning'}).then(() => {
          deleteOrderDataTemplate(row).then(res => {
            if (res.code === 200) {
              this.$message.success('删除成功');
              this.getTemplates()
              this.popoverVisible = true
            }
          })
        })

        // const index = this.gridData.findIndex(item => item.name === row.name);
        // if (index > -1) {
        //   this.gridData.splice(index, 1);
        // }
        // this.visible = false
      },
      // 清空搜索
      handleSearchClear() {
        this.searchQuery = '';
      },
      focusSearch() {
        this.getTemplates();
        this.popoverVisible = true;
        setTimeout(() => {
          //将鼠标光标移入搜索框
          this.$refs.searchInput.focus();
        },300);
      },
      handleRowClick(row) {
        // this.$emit('selectedAddress', row)
      },
      async getTemplates() {
        const res = await getOrderDataTemplateList()
        res.data.forEach(item => {
          item.details = JSON.parse(item.details)
        })
        this.gridData = res.data
      },
      handleClickOutside(event) {
        // 如果点击的元素不是容器元素的后代元素，关闭
        if (this.popoverVisible && !this.$refs.container.contains(event.target)) {
          this.popoverVisible = false
        }
      },
    },
    beforeDestroy() {
      // 在组件销毁前移除事件监听器
      document.removeEventListener('click', this.handleClickOutside);
    },
    mounted() {
      // 在mounted函数中添加全局点击事件监听器
      document.addEventListener('click', this.handleClickOutside);
      // this.getTemplates();
    }
  };
  </script>

  <style scoped lang="scss">
  .search-box {
    //margin-bottom: 15px;
  }

  .details-content {
    max-height: 38px;
    overflow: hidden;
    font-size: 12px;
    line-height: 1.4;
    text-align: left;
    display: -webkit-box;
    -webkit-line-clamp: 2; //行数
    -webkit-box-orient: vertical;
    white-space: pre-wrap;
    word-break: break-all;
  }

  .delete-btn {
    color: #F56C6C;
    margin-left: 24px;

    &:hover {
      color: #f78989;
    }
  }

  pre {
    margin: 0;
    font-family: inherit;
  }

  /deep/ .el-table .el-table__body tr:hover {
    cursor: pointer;
  }
  </style>



// WEBPACK FOOTER //
// src/views/new/order/components/ContractsTemplate.vue